import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { IPayAndPublishProps } from './types';

export const PayAndPublish = (props: IPayAndPublishProps) => {
  const { text, isDisabled, isPending, handleButtonClick } = props;

  return (
    <Button
      type="button"
      theme="fill_primary"
      onClick={handleButtonClick}
      disabled={isDisabled}
      loading={isPending}
      fullWidth
    >
      {text}
    </Button>
  );
};
